import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, ArrowLeft, Mail, Phone } from 'lucide-react';

const ThankYou = () => {
  return (
    <div style={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '20px',
        padding: '3rem',
        textAlign: 'center',
        maxWidth: '600px',
        width: '100%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.1)'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          background: 'linear-gradient(135deg, #48bb78 0%, #38a169 100%)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 2rem',
          boxShadow: '0 10px 30px rgba(72, 187, 120, 0.3)'
        }}>
          <CheckCircle size={40} color="white" />
        </div>

        <h1 style={{
          fontSize: '2.5rem',
          fontWeight: 'bold',
          color: '#2d3748',
          marginBottom: '1rem'
        }}>
          Thank You! 🎉
        </h1>

        <p style={{
          fontSize: '1.2rem',
          color: '#4a5568',
          marginBottom: '2rem',
          lineHeight: '1.6'
        }}>
          Your message has been successfully submitted to ESN Publications. 
          We appreciate your interest and will get back to you within 24 hours.
        </p>

        <div style={{
          background: '#f7fafc',
          padding: '1.5rem',
          borderRadius: '12px',
          marginBottom: '2rem'
        }}>
          <h3 style={{
            fontSize: '1.1rem',
            fontWeight: '600',
            color: '#2d3748',
            marginBottom: '1rem'
          }}>
            What happens next?
          </h3>
          <ul style={{
            textAlign: 'left',
            color: '#4a5568',
            lineHeight: '1.8'
          }}>
            <li>✅ We'll review your message carefully</li>
            <li>📧 You'll receive a response within 24 hours</li>
            <li>🤝 We'll discuss how we can help you</li>
          </ul>
        </div>

        <div style={{
          display: 'flex',
          gap: '1rem',
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          <Link 
            to="/" 
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.75rem 1.5rem',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '8px',
              fontWeight: '600',
              transition: 'transform 0.2s ease'
            }}
            onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
            onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
          >
            <ArrowLeft size={18} />
            Back to Home
          </Link>

          <a 
            href="mailto:contactus@esnresearch.in"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.75rem 1.5rem',
              background: 'transparent',
              color: '#667eea',
              textDecoration: 'none',
              border: '2px solid #667eea',
              borderRadius: '8px',
              fontWeight: '600',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#667eea';
              e.target.style.color = 'white';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'transparent';
              e.target.style.color = '#667eea';
            }}
          >
            <Mail size={18} />
            Email Us
          </a>
        </div>

        <div style={{
          marginTop: '2rem',
          padding: '1rem',
          background: '#edf2f7',
          borderRadius: '8px',
          fontSize: '0.9rem',
          color: '#4a5568'
        }}>
          <strong>Need immediate assistance?</strong><br />
          Call us at <a href="tel:+918838173189" style={{ color: '#667eea', textDecoration: 'none' }}>+91 88381 73189</a>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;